"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindApplicantsByEmailOrPhoneItemToJSON = exports.FindApplicantsByEmailOrPhoneItemFromJSONTyped = exports.FindApplicantsByEmailOrPhoneItemFromJSON = void 0;
const _1 = require("./");
function FindApplicantsByEmailOrPhoneItemFromJSON(json) {
    return FindApplicantsByEmailOrPhoneItemFromJSONTyped(json, false);
}
exports.FindApplicantsByEmailOrPhoneItemFromJSON = FindApplicantsByEmailOrPhoneItemFromJSON;
function FindApplicantsByEmailOrPhoneItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enrollmentId': json['enrollmentId'],
        'name': _1.NameObjectFromJSON(json['name']),
        'dateOfBirth': (new Date(json['dateOfBirth'])),
        'mailingAddressLine1': json['mailingAddressLine1'],
        'product': json['product'],
    };
}
exports.FindApplicantsByEmailOrPhoneItemFromJSONTyped = FindApplicantsByEmailOrPhoneItemFromJSONTyped;
function FindApplicantsByEmailOrPhoneItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enrollmentId': value.enrollmentId,
        'name': _1.NameObjectToJSON(value.name),
        'dateOfBirth': (value.dateOfBirth.toISOString().substr(0, 10)),
        'mailingAddressLine1': value.mailingAddressLine1,
        'product': value.product,
    };
}
exports.FindApplicantsByEmailOrPhoneItemToJSON = FindApplicantsByEmailOrPhoneItemToJSON;
//# sourceMappingURL=FindApplicantsByEmailOrPhoneItem.js.map